import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Block } from '@uncinc/react-drupal-core';
import { ParagraphCTA as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphCTAProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphCTA: React.FC<ParagraphCTAProps> = ({ entity }) => {
  const uuid = entity.getIn(['uuid', 0, 'value']);
  const ctaBlockEntity = entity.getIn(['field_cta_block', 0, 'entity'], Immutable.Map());

  return (
    <div id={uuid} className="ParagraphCTA">
      <Container>
        <div className="row">
          <div className="col-12">
            <Block entity={ctaBlockEntity} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphCTA;
